import { Component } from '@theme/component';

class SpinVideoFeature extends Component {
  connectedCallback() {
    super.connectedCallback();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const video = this.#getVideo();
      if (video) {
        video.autoplay = false;
        video.pause();
      }
      this.#setPausedState(true);
    }
  }

  togglePlayback() {
    const video = this.#getVideo();
    if (!video) return;

    if (video.paused) {
      const playPromise = video.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise.then(() => this.#setPausedState(false)).catch(() => {});
      } else {
        this.#setPausedState(false);
      }
    } else {
      video.pause();
      this.#setPausedState(true);
    }
  }

  #getVideo() {
    return this.querySelector('video');
  }

  #setPausedState(isPaused) {
    const { toggle, iconPause, iconPlay } = this.refs;
    if (!toggle) return;

    toggle.setAttribute('aria-pressed', isPaused ? 'true' : 'false');
    const label = isPaused ? toggle.dataset.labelPlay : toggle.dataset.labelPause;
    if (label) toggle.setAttribute('aria-label', label);

    if (iconPause) iconPause.hidden = isPaused;
    if (iconPlay) iconPlay.hidden = !isPaused;
  }
}

customElements.define('spin-video-feature', SpinVideoFeature);
